// Paged list reads (agion/Agion#3391).

/**
 * The offset of the next page of a paged list read: one page on, by the limit
 * the server answered with (its clamp of the limit asked), or by the limit
 * asked when the server answered none or answered something that is not a
 * positive whole number. Never by the rows received, so a page that came back
 * short does not shift the next page and repeat its rows.
 */
export function nextPageOffset(offset: number, answeredLimit: unknown, askedLimit: number): number {
  const page = typeof answeredLimit === 'number' && Number.isInteger(answeredLimit) && answeredLimit > 0
    ? answeredLimit
    : askedLimit
  return offset + page
}
